export enum UserGroup {
    ALL = "0",
}

export enum UpdateKeyListIdCards {
    INITIALS = "INITIALS",
    EMAIL = "EMAIL",
    EMPLOYEE_NUMBER = "EMPLOYEE_NUMBER",
}

export type UserGroups = Readonly<{
    id: number
    name: string
    domains: Domain[]
    isActive: boolean
}>

type Domain = Readonly<{
    id: number
    domain: string
}>

export type ImportIdCardsFormValues = Readonly<{
    userGroupId: string
    updateKey: UpdateKeyListIdCards
    updateMatching: boolean
    deleteUnmatched: boolean
    file: null | Blob
}>
